import { render, staticRenderFns } from "./shoutlist.vue?vue&type=template&id=3be7af2e&scoped=true"
import script from "./shoutlist.vue?vue&type=script&lang=js"
export * from "./shoutlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be7af2e",
  null
  
)

export default component.exports